import React from 'react';
import PropTypes from 'prop-types';
import ContactUsIcon from 'products/nomad_insurance/assets/img/claims/contact-us.svg';
import { StyledButton } from '../../styled';
import useClaimProgression from '../../../../hooks/useClaimProgression';
import { StyledImg } from './styled';

const ContactUsButton = ({ claim }) => {
  const { isDeclined } = useClaimProgression(claim);

  if (!isDeclined) return null;

  return (
    <StyledButton
      color="pickledBluewood"
      onClick={() => window.Intercom('showNewMessage')}
      thickness="thin"
      variant="outline"
    >
      <StyledImg src={ContactUsIcon} alt="Contact us" />
      Contact us
    </StyledButton>
  );
};

ContactUsButton.propTypes = {
  claim: PropTypes.any.isRequired
};

export default ContactUsButton;
